module.exports = __webpack_public_path__ + "static/media/main_visual_skid_steer_loaders_1350_r_nxt2_manitou.70b1f5e0.jpg";